(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
        class ProductInfoDrawer extends HTMLElement {
          constructor() {
            super();
            this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
          }

          open(triggeredBy) {
            if (triggeredBy) this.activeElement = triggeredBy;
            this.classList.add('animate', 'active');
            document.body.classList.add('overflow-hidden');
            const focusElement = this.querySelector('.drawer__inner');
            this.addEventListener(
              'transitionend',
              () => { if (focusElement) focusElement.focus(); },
              { once: true }
            );
          }

          close() {
            this.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
            if (this.activeElement) this.activeElement.focus();
          }
        }

        if (!customElements.get('product-info-drawer')) {
          customElements.define('product-info-drawer', ProductInfoDrawer);
        }
      
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pl-welcome-popup"]) return;
  try {
    
    class PLWelcomePopup extends HTMLElement {
      constructor() {
        super();
        this.storageKey = 'pl-welcome-popup-seen';
        this.subscribedKey = 'pl-welcome-popup-subscribed';
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      }

      connectedCallback() {
        let alreadySubscribed = false;
        try {
          alreadySubscribed = window.localStorage.getItem(this.subscribedKey) === 'true';
        } catch (e) {
          alreadySubscribed = false;
        }
        if (alreadySubscribed && !window.Shopify?.designMode) return;

        let alreadySeen = false;
        try {
          alreadySeen = window.sessionStorage.getItem(this.storageKey) === 'true';
        } catch (e) {
          alreadySeen = false;
        }
        if (alreadySeen && !window.Shopify?.designMode) return;

        const delay = window.Shopify?.designMode ? 300 : (Number(this.dataset.delay) || 3000);
        window.setTimeout(() => this.open(), delay);
      }

      markSubscribed() {
        try {
          window.localStorage.setItem(this.subscribedKey, 'true');
        } catch (e) {
          // localStorage unavailable
        }
      }

      open() {
        this.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
        try {
          window.sessionStorage.setItem(this.storageKey, 'true');
        } catch (e) {
          // sessionStorage unavailable, popup will just show again next time
        }
        const focusTarget = this.querySelector('.pl-welcome-popup__inner');
        if (focusTarget) window.requestAnimationFrame(() => focusTarget.focus());
      }

      close() {
        this.classList.remove('active');
        document.body.classList.remove('overflow-hidden');
      }
    }

    function plRestyleClientifyForm(root) {
      const plSerif = "'Cormorant Garamond', 'Iowan Old Style', Baskerville, Georgia, serif";
      const submit = root.querySelector('input[type="submit"]');
      if (submit) {
        submit.style.setProperty('background-color', '#55534c', 'important');
        submit.style.setProperty('border-color', '#55534c', 'important');
        submit.style.setProperty('color', '#fff', 'important');
        submit.style.setProperty('border-radius', '8px', 'important');
        submit.style.setProperty('font-family', plSerif, 'important');
        submit.style.setProperty('font-size', '1.25rem', 'important');
        submit.style.setProperty('text-transform', 'none', 'important');
        submit.style.setProperty('box-shadow', 'none', 'important');
      }
      const emailInput = root.querySelector('input[type="email"], input[type="text"]');
      if (emailInput) {
        emailInput.style.setProperty('border-radius', '4px', 'important');
        emailInput.style.setProperty('font-family', plSerif, 'important');
        emailInput.style.setProperty('font-size', '1.15rem', 'important');
      }
      root.querySelectorAll('label, h4').forEach((label) => {
        label.style.setProperty('font-family', plSerif, 'important');
        label.style.setProperty('font-size', '1.15rem', 'important');
      });
      root.querySelectorAll('div[style*="background: rgb("]').forEach((box) => {
        if (box.id === 'form_error_id' || box.id === 'form_success_id') return;
        box.style.setProperty('background', 'transparent', 'important');
        box.style.setProperty('padding', '0', 'important');
        box.style.setProperty('width', '100%', 'important');
      });
    }

    const plClientifyWrap = document.querySelector('[id^="clientify-webform-"]');
    if (plClientifyWrap) {
      plRestyleClientifyForm(plClientifyWrap);
      const plPopupEl = plClientifyWrap.closest('pl-welcome-popup');
      const plClientifyObserver = new MutationObserver(() => {
        plRestyleClientifyForm(plClientifyWrap);
        const successBox = plClientifyWrap.querySelector('#form_success_id');
        if (successBox && successBox.style.display !== 'none' && plPopupEl) {
          plPopupEl.markSubscribed();
        }
      });
      plClientifyObserver.observe(plClientifyWrap, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    }

    if (!customElements.get('pl-welcome-popup')) {
      customElements.define('pl-welcome-popup', PLWelcomePopup);
    }

  } catch(e) { console.error(e); }
})();
})();
